import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import calendar from '../assets/icons/calendar.svg';
import { useTranslation } from 'react-i18next';
import { buttonLike } from 'reusable/buttonLike';

type DateRangeFilterProps = {
  defaultStartDate?: string;
  defaultEndDate?: string;
  onDateRangeChange: (startDate: string, endDate: string) => void;
  position?: 'left' | 'right';
};

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  defaultStartDate,
  defaultEndDate,
  onDateRangeChange,
  position = 'left',
}) => {
  const { t } = useTranslation('common');
  const [startDate, setStartDate] = useState<Date | undefined>(
    defaultStartDate ? new Date(defaultStartDate) : undefined
  );
  const [endDate, setEndDate] = useState<Date | undefined>(
    defaultEndDate ? new Date(defaultEndDate) : undefined
  );
  const [isOpen, setIsOpen] = useState(false);

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start || undefined);
    setEndDate(end || undefined);
    if (start && end) {
      onDateRangeChange(
        start.toLocaleDateString('en-CA'),
        end.toLocaleDateString('en-CA')
      );
    }
  };

  const getPositionClasses = () => {
    if (position === 'right') {
      return 'right-1/3 transform translate-x-1/2';
    }
    return 'left-1/3 transform -translate-x-1/2';
  };

  return (
    <div className="relative">
      <div
        className="flex items-center border px-3 py-2 rounded-md cursor-pointer text-gray-500"
        {...buttonLike(() => setIsOpen(!isOpen))}
        aria-expanded={isOpen}
      >
        <img src={calendar} alt="" className="mr-2" />
        <span>
          {startDate && endDate
            ? `${startDate.toLocaleDateString(
                'en-CA'
              )} - ${endDate.toLocaleDateString('en-CA')}`
            : t('date-filter.range')}
        </span>
      </div>
      {isOpen && (
        <div className={`absolute mt-2 z-10 ${getPositionClasses()}`}>
          <DatePicker
            selected={startDate}
            onChange={handleDateChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            inline
            monthsShown={2}
            onClickOutside={() => setIsOpen(false)}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
